export const EventsType = {
    COMMON: 0,
    MAINTENANCE: 1,
};
